import { FC, useCallback } from 'react';

import StageSuccessPage from 'features/Onboarding/legacy/components/StageSuccessPage';

import PageProps from '../PageProps';
import locales from './locales';

const BusinessInfoComplete: FC<PageProps> = ({ setCurrentPage }) => {
  const actionButtonOnPress = useCallback(() => {
    setCurrentPage('verification-guide');
  }, [setCurrentPage]);

  return (
    <StageSuccessPage
      actionButton={{
        label: locales.continueCta,
        onPress: actionButtonOnPress,
      }}
      description={locales.completeMessage}
      title={locales.title}
      withNoBackButton
    />
  );
};

export default BusinessInfoComplete;
